export const API_PATH_ACCOMMODATION:string = "/admin/accommodations"

export const COOKIE_NAME_ACCOMMODATION_LIST:string = "accommodation_list"